createSafeModule('app.cessao', [
    'ui.router',
    'ngResource',
    'lazyLoad'
]);